import moment from "moment";

export const calendarTime = (date: any) => {
  const m = moment(date);

  if (!m.isValid()) return "";

  const diffMinutes = moment().diff(m, "minutes");

  if (diffMinutes < 1) {
    return "now";
  } else if (diffMinutes < 60) {
    return m.fromNow(); // "5 minutes ago"
  } else {
    return m.calendar(null, {
      sameDay: "[Today at] h:mm A",
      nextDay: "[Tomorrow]",
      nextWeek: "dddd",
      lastDay: "[Yesterday at] h:mm A",
      lastWeek: "[Last] dddd",
      sameElse: "DD/MM/YYYY",
    });
  }
};
